import { inject, Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import {
  Agreement,
  AgreementsService,
  AgreementStatus,
  ConsolidatedAgreementsRestService
} from '@tdwb/lazy/platform/preferences';

@Injectable()
export class WebbrokerAgreementsService {
  private readonly consolidatedAgreementsRestService = inject(ConsolidatedAgreementsRestService);
  private readonly agreementsService = inject(AgreementsService);

  saveAgreementsWithNoClientData(agreements: Array<Agreement>): Observable<void> {
    const agreementsInfo: Array<Agreement> = [];
    agreements.forEach((agreement: Agreement): void => {
      agreementsInfo.push({
        agreementType: agreement.agreementType,
        agreementStatus: AgreementStatus.ACCEPTED,
        exchangeSubscriptionData: {}
      });
    });
    return this.consolidatedAgreementsRestService.saveAgreements(agreementsInfo)
      .pipe(tap((): void => this.agreementsService.syncCachedAgreements(agreementsInfo)));
  }
}
